import { http } from "../api/http";

export const SUPPORT_ACCESS_DENIED_MESSAGE =
  "Acesso restrito. Seu usuário não está autorizado no painel de suporte (SUPPORT_AGENT_USER_IDS no IAM).";

/**
 * Valida no backend (IAM) se o ID interno do usuário está em SUPPORT_AGENT_USER_IDS.
 * Lança erro se 403 / não permitido.
 */
export async function assertSupportPanelAccess() {
  try {
    const { data } = await http.get("/api/iam/me/support-panel");
    if (!data?.allowed) {
      throw new Error(SUPPORT_ACCESS_DENIED_MESSAGE);
    }
    return true;
  } catch (error) {
    const status = error?.response?.status;
    if (status === 403) {
      throw new Error(SUPPORT_ACCESS_DENIED_MESSAGE);
    }
    const msg =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      SUPPORT_ACCESS_DENIED_MESSAGE;
    throw new Error(typeof msg === "string" ? msg : SUPPORT_ACCESS_DENIED_MESSAGE);
  }
}
